import {SegmentedMessage} from "sms-segments-calculator";


interface SegmentInfo {
  charCount: number;
  maxCharCount: number;
  segmentsCount: number;
  encodingName: 'GSM-7' | 'UCS-2';
  previewHtml: string;
}

function getSegmentInfo(str: string): SegmentInfo{
  const linkReg = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/gi;
  const tempLinkReg = /\{\{ *(addToCartUrl|abandonedCheckoutUrl|facebookLink|instagramLink|youtubeLink|tiktokLink|unsubscribeLink) *\}\}/gi;
  const exampleLink = 'https://ctx4.co/xxxxxxxxxx';
  const suffix = ' Text STOP to opt-out';
  const previewHtml = str
    .replace(
      linkReg,
      `<a href="javascript:void(0)" class="short-link">${exampleLink}</a>`
    )
    .replace(
      tempLinkReg,
      `<a href="javascript:void(0)" class="short-link">${exampleLink}</a>`
    )
    + suffix;
  const segmentedMessage = new SegmentedMessage(str
    .replace(linkReg, exampleLink)
    .replace(tempLinkReg, exampleLink)
    + suffix);
  const segments = segmentedMessage.segments;
  const segmentsCount = segments.length;
  const encodingName = segmentedMessage.encodingName;
  const segmentMaxCharCount = encodingName === 'GSM-7'?
    (segmentsCount === 1? 160 : 153) :
    (segmentsCount === 1? 70 : 67);
  const maxCharCount = segmentMaxCharCount * segmentsCount;
  // 为了解决4字节编码分段导致的数量统计问题，数量统计公式为 segmentMaxCharCount * (segmentsCount - 1) + 最后一个segments的字节数量
  const charCount = segmentMaxCharCount * (segmentsCount - 1) + segments[segmentsCount - 1].reduce((total, char)=>{
    total += (char.codeUnits? char.codeUnits.length : 0);
    return total;
  },0)

  return {
    charCount,
    maxCharCount,
    segmentsCount,
    encodingName,
    previewHtml
  }
}

export {
  SegmentInfo,
  getSegmentInfo
}